import { createSelector } from "reselect";
import { IAppState } from "..";

export const getAllModalsStates = (state: IAppState) => state.modals;

export const isAddTargetModalOpen = createSelector(
  getAllModalsStates,
  modals => modals.addTargetModal.isVisible
);
